import React from "react";
import {Box, Button, Typography} from "@mui/material";
import {findCurrentTranslateLabel} from "../../com/globalsFunctions/globalFunctions";
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {toggleContactUsPopup} from "../../store/actionsCreator/controlsActionsCreator";
import {makeStyles} from "@mui/styles";

const useStyle = makeStyles(() => ({
    powerTooltip: (props: any) => ({
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        flexFlow: `column`,
        "& .MuiTypography-root": {
            fontFamily: props.fontFamily,
        },
    })
}))

const PowerByTooltipContent = () => {
    const dispatch = useDispatch();
    const {data} = useSelector((state: IAppState) => state.flyersBranch);
    const isHebrew = data?.dir.toLowerCase() === 'rtl';
    const styleProperties = {
        fontFamily: data?.font.toLowerCase()
    }
    const classes = useStyle(styleProperties)

    const messageForUserCaption = findCurrentTranslateLabel(645, "To receive more info on", data);
    const contactCaption = findCurrentTranslateLabel(646, "Contact Us", data);

    const onClick = () => {
        dispatch(toggleContactUsPopup());
    }

    return (
        <Box
            className={classes.powerTooltip}
            sx={{direction: isHebrew ? `rtl` : `ltr`}}
        >
            <Box>
                <Typography sx={{
                    width: `160px`,
                    textAlign: `center`,
                }}>
                    {messageForUserCaption}
                </Typography>
            </Box>
            <Button
                sx={{
                    textTransform: `initial`
                }}

                onClick={onClick}
            >
                <Typography color={`blue`} >
                    {contactCaption}
                </Typography>
            </Button>
        </Box>
    )
}

export default PowerByTooltipContent;